import {
  GetListOfFlashcards_URL,
  GetTotalNumberofFlashcards_URL,
  POST_METHOD,
  SetUserFlashcardCounts_URL,
} from '../../Apis/api';

export const fetchFlashCardCount = userId => {
  /*fetch total number of cards*/
  return fetch(GetTotalNumberofFlashcards_URL, {
    method: POST_METHOD,
    body: JSON.stringify(userId),
  }).then(response => {
    return response.json();
  });
};

export const fetchListOfCards = (userId) => {

  return (fetch(GetListOfFlashcards_URL, {
    method: POST_METHOD,
    body: JSON.stringify(userId),
  }).then((response) => {
    return response.json();
  }));
};

export const submitFlashcardDetails_API = flashCardData => {

  /* submit flashcard details */
  return fetch(SetUserFlashcardCounts_URL, {
    method: POST_METHOD,
    body: JSON.stringify(flashCardData),
  }).then(response => {

    return response.json();
  });
};
